import { Component, OnDestroy, OnInit, Inject, ElementRef } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

import {  Observable, map, of, startWith, switchMap, throwError } from 'rxjs';

import { UserService } from '../../services/user.service';
import { RoleService } from '../../services/role.service';
import { Role } from '../../models/role';
import { AlertDialog, AlertDialogConfig } from '../alert/dialog';
import { User } from '../../models/user';

@Component({
  standalone: false,
  selector: 'app-add-user',
  templateUrl: './add-user-template.html',
  styleUrls: ['./add-user-style.scss'],
})
export class AddUserComponent implements OnInit {
  userForm = this.fb_.group({
    id: null,
    email: [this.data?.email, [Validators.required, Validators.email]],
    roles_list: [this.data?.roles_list || [], [Validators.required]],
    groups: [this.data?.groups],
    rolesInput: []
  });
  processing: boolean = false;
  rolesListDictionary: Role[] = [];
  selectedOptions: Role[] = [];
  rolesInput!: ElementRef<HTMLInputElement>;
  filteredEmail!: Observable<any[]> | undefined ;

  constructor(
    public dialogRef: MatDialogRef<AddUserComponent>,
    private userService: UserService,
    private rolesService: RoleService,
    private fb_: FormBuilder,
    private dialog_: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: User
  ) { }

  ngOnInit(): void {
    this.rolesService.get().subscribe(result => this.rolesListDictionary = result);
    console.log("patch value ", this.data || {})
    this.userForm.patchValue((this.data || {}) as any);

    this.filteredEmail = this.userForm.get('email')?.valueChanges
            .pipe(
              startWith(''),
              switchMap(value => this._filter(value || '')),
            );
  }


  get email(): AbstractControl | null {
    return this.userForm.get('email');
  }

  get roles(): FormGroup {
    return this.userForm.get('roles') as unknown as FormGroup;
  }

  selectedOption(value: any){
    console.log('selectedOption ', value);
    this.selectedOptions.push(value);
  }

  selectedUser(option: any){
    console.log('selectedUser ', option);
    let user = this.userForm.value;
    console.log('current user value: ', user);
    if (option && typeof option === 'object' && option.id) {
      const combinedGroups = new Set([ ...(user.groups || []), ...(option.groups || [])]);
      option.groups = Array.from(combinedGroups);
    }
    console.log('merged user value: ', option);
    this.userForm.patchValue(option);
    this.userForm.get('email')?.setValue(option.email);
  }

  removeOption(option: Role) {
    const index = this.selectedOptions.indexOf(option);
    if (index >= 0) {
      this.selectedOptions.splice(index, 1);
    }
  }

  async add(): Promise<void> {
    let user = {
      // id: this.data?.id,
      ...this.userForm.value,
    }
    this.processing = true;
    this.userService.addUser(user).subscribe( response => {
      if (!response.status) {
        this.openAlertDialog('Erreur', `Une erreur est survenue lors de l'ajout de cet utilisateur : ${response.message}`);
      } else {
        this.dialogRef.close(true);
      }
      this.processing = false;
    }, error => {
      this.openAlertDialog('Erreur', `Une erreur est survenue lors de l'ajout de cet utilisateur : ${error}`);
      return throwError(error);
    });
  }

  private openAlertDialog(title: string, message: string) {
    const config = { title, message, confirmLabel: 'OK' } as AlertDialogConfig;
    this.dialog_.open(AlertDialog, {data: config});
  }

  private _filter(query: string): Observable<any[]> {
    return this.userService.searchUser(query);
  }
}
